export default {
  address: 'Koti-osoite *',
  // Welcome Bonus Promotion on Create Account
  'create-account-247-support': '24/7 Asiakastuki',
  'create-account-secure': '100% Turvallinen',
  'create-account-fast': 'Nopeat ja helpot nostot',
  'create-account-gambling-commission': 'Gambling Commission',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Tervetuloabonus',
  'create-account-promotion-description': 'jopa ##UPTO_AMOUNT## asti ensimmäisellä talletuksellasi',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## ilmaiskierrosta',

  //need translations!
  'create-account-promotion-sign-in': 'Onko sinulla jo käyttäjätili?',
  'create-account-close': 'close',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Ehdot ovat.</a> Ole hyvä ja pelaa vastuullisesti. <a href="http://www.gamblingtherapy.org/fi" target="_blank">www.Gamblingtherapy.org</a>',

  'personal-details-title': 'Rekisteröidy',
  'personal-details-supporting-text': 'Kolme helppoa askelta',
  'address-details-title': 'Melkein Perillä!',
  'address-details-supporting-text': '  ',
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'Viimeinen askel vielä',

  'marketing-preferences-title': 'Viestinnän asetukset',
  'marketing-preferences-description':
    'Ursa Casino tarjoaa pelaajilleen ainutlaatuisia päivittäistarjouksia ja kuukausittaisia kohokohtia, kuten talletusbonuksia, bonuskierroksia, ilmaiskierroksia, cashback-tarjouksia, turnauksia, tulostaulukoita, muita palkintoja, kokemuksia ja lomia. Jos haluat kuulla näistä, valitse alla olevista vaihtoehdoista:',
  'marketing-preferences-post-text': 'Voit päivittää viestintäasetuksesi milloin tahansa tili-osiossa.',
  'marketing-preferences-label-cross-brand': 'Haluan kuulla eksklusiivisista tarjouksista kasinoverkostolta.',
  'marketing-preferences-label-brand-only': 'Haluan kuulla eksklusiivisista tarjouksista vain tältä kasinolta.',
  'marketing-preferences-label-email': 'Haluan kuulla tarjouksista <strong>sähköpostitse</strong>.',
  'marketing-preferences-label-sms': 'Haluan kuulla tarjouksista <strong>tekstiviestillä</strong>',
  'marketing-preferences-label-phone-call': 'Haluan kuulla tarjouksista <strong>puhelimen kautta</strong>',
  'marketing-preferences-label-post': 'Haluan kuulla tarjouksista <strong>postitse</strong>',

  'marketing-preferences-unified-description':
    '<strong>Ethän ohita viimeisimpiä</strong> Ursa Casino:n ja <a href="/brands" target="_blank">koko peliverkkomme</a> kampanjoita ja erikoistarjouksia. Valitse millä tavalla toivot meidän ottavan yhteyttä.',
  'marketing-preferences-unified-label-email': 'Sähköpostitse',
  'marketing-preferences-unified-label-sms': 'Tekstiviestillä',
  'marketing-preferences-unified-label-phone-call': 'puhelimen kautta',
  'marketing-preferences-unified-label-phone-post': 'Postitse',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>24/7 Asiakastuki</li><li class='one-hundred-percent-secure'>100% Turvallinen</li><li class='usp-fast'>Nopeat ja helpot nostot</li></ul>",
};
